import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Officepickupanddropserviceinpune() {



  const cardData =
  {
    keyword: 'Office Pickup and Drop Service in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Office Pickup and Drop Service in Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited provides smooth and dependable Office Pickup and Drop Service in Pune, designed for employees, corporate teams, IT companies, and business organizations that require daily, punctual transportation. Our fleet of clean, air-conditioned sedans, SUVs, and staff-transport vehicles ensures a comfortable commuting experience every day. With professional chauffeurs, GPS-enabled cars, and well-planned routes, we guarantee safe, timely, and hassle-free office travel. Whether your company needs individual employee pickup and drop, bulk staff transportation, shift-based cabs, or dedicated monthly vehicles, Pune Corporate Cars India Private Limited delivers reliable, efficient, and cost-effective office commute solutions tailored to your organization’s needs.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Employee Transportation Pune",
    "description": "Employee Transportation Pune provides reliable, safe, and timely commuting solutions for employees working across Pune’s IT hubs, corporate parks, and industrial zones. With AC sedans, SUVs, shuttle vans, and tempo travellers, we manage multi-route and multi-shift travel requirements. Verified chauffeurs, GPS tracking, and clean vehicles ensure smooth daily travel. Employee Transportation Pune helps companies improve punctuality, safety, and workforce convenience."
  },
  {
    "name": "Staff Shuttle Service Pune",
    "description": "Staff Shuttle Service Pune offers high-capacity shuttles for large corporate teams and IT companies. Our AC minibuses and tempo travellers operate on fixed schedules with optimized routing for peak hours. Ideal for tech parks, business centres, and manufacturing units, the service ensures efficient, economical, and well-coordinated staff mobility throughout the day."
  },
  {
    "name": "Office Commute Cab Pune",
    "description": "Office Commute Cab Pune delivers structured and comfortable cab services for employees traveling to and from their workplace. With clean interiors, professional chauffeurs, and on-time pickups, this service supports daily travel across Pune’s commercial and IT corridors. Office Commute Cab Pune ensures a convenient and stress-free commuting solution for all staff members."
  },
  {
    "name": "Pune Employee Pick Drop",
    "description": "Pune Employee Pick Drop provides punctual and well-managed daily pickup and drop services designed for companies across Pune. Our vehicles support multiple shifts, night travel, and custom pickup points. With GPS monitoring and trained drivers, Pune Employee Pick Drop guarantees safe, reliable, and efficient staff commuting."
  },
  {
    "name": "Company Cab Service Pune",
    "description": "Company Cab Service Pune offers customized cab solutions for corporate operations, including executive travel, staff commute, client visits, and inter-office movement. Our fleet consists of AC sedans, SUVs, and vans maintained to high standards. Company Cab Service Pune ensures professional, flexible, and dependable mobility for organizations of all sizes."
  },
  {
    "name": "Corporate Staff Mobility Pune",
    "description": "Corporate Staff Mobility Pune provides end-to-end mobility solutions for companies needing structured transportation for staff and executives. We handle route planning, shift schedules, driver management, and vehicle hygiene. Corporate Staff Mobility Pune ensures smooth, safe, and coordinated travel for the entire workforce."
  },
  {
    "name": "Best Office Transport Pune",
    "description": "Best Office Transport Pune delivers top-rated commuting services with punctual pickups, disciplined drivers, and premium AC vehicles. Ideal for corporate teams, executives, and IT professionals, this service ensures a comfortable and professional travel experience. Best Office Transport Pune is trusted by leading companies for daily office mobility."
  },
  {
    "name": "Affordable Staff Pick Drop Pune",
    "description": "Affordable Staff Pick Drop Pune provides cost-effective and dependable staff travel solutions for small, medium, and large organizations. Despite being budget-friendly, our vehicles are sanitized, AC-equipped, and regularly serviced. Affordable Staff Pick Drop Pune helps companies reduce travel costs while maintaining reliable employee transportation."
  },
  {
    "name": "Office Employee Shuttle Pune",
    "description": "Office Employee Shuttle Pune offers group transportation for companies requiring shuttle-based commuting. Our AC minibuses and vans cover fixed routes and multiple shift timings. Perfect for IT parks, industrial clusters, and corporate hubs, Office Employee Shuttle Pune ensures smooth and efficient group movement every day."
  },
  {
    "name": "Daily Pick Drop Cab Pune",
    "description": "Daily Pick Drop Cab Pune ensures consistent, on-time daily travel for employees across Pune. Designed for routine office commuting, this service includes AC vehicles, trained chauffeurs, and well-planned routes. Daily Pick Drop Cab Pune guarantees a dependable and comfortable travel experience for the workforce."
  },
  {
    "name": "Monthly Office Transport Pune",
    "description": "Monthly Office Transport Pune provides long-term cab rentals with dedicated drivers assigned to your organization. Monthly billing, priority support, and vehicle availability make it ideal for companies with daily staff commuting needs. Monthly Office Transport Pune ensures steady, cost-efficient, and professional mobility."
  },
  {
    "name": "Corporate Working Staff Cab",
    "description": "Corporate Working Staff Cab offers well-managed cab services for employees working in different shifts and locations. Our service focuses on safety, punctuality, and comfort with AC-equipped vehicles and responsible drivers. Corporate Working Staff Cab ensures smooth and reliable commuting for all working staff members."
  },
  {
    "name": "Business Pick Drop Service Pune",
    "description": "Business Pick Drop Service Pune provides professional travel solutions for executives, managers, and corporate teams. Whether for daily commute, business meetings, or client visits, our cabs offer AC comfort, clean interiors, and punctual service. Business Pick Drop Service Pune enhances productivity by ensuring smooth mobility."
  },
  {
    "name": "IT Office Pickup Drop Pune",
    "description": "IT Office Pickup Drop Pune offers transportation designed specifically for IT companies operating in Hinjewadi, Kharadi, Magarpatta, and other tech hubs. With multi-shift support, optimized routes, and strict night safety protocols, IT Office Pickup Drop Pune ensures consistent and secure commuting for IT employees."
  },
  {
    "name": "Corporate Commute Provider Pune",
    "description": "Corporate Commute Provider Pune delivers comprehensive commute management for organizations, including fleet allocation, route optimization, scheduling, driver management, and safety monitoring. With AC vehicles and professional drivers, Corporate Commute Provider Pune ensures dependable, cost-efficient, and scalable mobility for businesses."
  }
],
"tableData": [
  ["Employee Transportation Pune", "Staff Shuttle Service Pune"],
  ["Office Commute Cab Pune", "Pune Employee Pick Drop"],
  ["Company Cab Service Pune", "Corporate Staff Mobility Pune"],
  ["Best Office Transport Pune", "Affordable Staff Pick Drop Pune"],
  ["Office Employee Shuttle Pune", "Daily Pick Drop Cab Pune"],
  ["Monthly Office Transport Pune", "Corporate Working Staff Cab"],
  ["Business Pick Drop Service Pune", "IT Office Pickup Drop Pune"],
  ["Corporate Commute Provider Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Office Pickup and Drop Service in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable and convenient office pickup and drop services in Pune, ensuring punctual and comfortable daily commuting for employees."
  },
  {
    "WhyChooseheading": "Ideal for Corporate & IT Companies",
    "WhyChoosedescription": "Our services are designed for all types of businesses, including IT companies, corporate offices, startups, and industrial firms across Pune."
  },
  {
    "WhyChooseheading": "Clean, Safe & Comfortable Vehicles",
    "WhyChoosedescription": "All our cabs are well-maintained and sanitized regularly to provide a safe, hygienic, and comfortable ride every day."
  },
  {
    "WhyChooseheading": "Transparent & Affordable Pricing",
    "WhyChoosedescription": "We offer clear and competitive pricing with no hidden charges, suitable for both small teams and large corporate employee transport plans."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Timings",
    "WhyChoosedescription": "Customize your pickup and drop schedules based on office timings, employee shifts, and daily work requirements."
  },
  {
    "WhyChooseheading": "Professional & Punctual Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs ensure timely pickups, safe driving, and a smooth travel experience for all employees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "We provide round-the-clock assistance for emergency requests, schedule changes, and booking updates."
  },
  {
    "WhyChooseheading": "Easy & Fast Booking Process",
    "WhyChoosedescription": "Book your office pickup and drop service easily through our online platform or phone, with instant confirmation and reliable service."
  }
]























  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited provide office pickup and drop services in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and timely office pickup and drop services across all major locations in Pune.',
  },
  {
    question: 'How can I book office pickup and drop services in Pune?',
    answer: 'You can book through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'Are your pickup and drop services suitable for corporate employees?',
    answer: 'Absolutely. Our services are tailored for employees with fixed or rotational work shifts.',
  },
  {
    question: 'What types of vehicles are available for office commute in Pune?',
    answer: 'We provide hatchbacks, sedans, SUVs, and corporate fleets depending on your team size and requirements.',
  },
  {
    question: 'Can companies choose monthly packages for employee transportation?',
    answer: 'Yes, we offer flexible and cost-effective monthly packages for corporate employee commute.',
  },
  {
    question: 'Do you provide shift-based office pickup and drop services?',
    answer: 'Yes, we support all shift timings including early morning, late night, and rotational shifts.',
  },
  {
    question: 'Is real-time tracking available for office commute vehicles?',
    answer: 'Yes, all our vehicles are equipped with GPS tracking to ensure safety and transparency.',
  },
  {
    question: 'What safety measures do you follow for daily office commute?',
    answer: 'Our cabs are sanitized regularly, and drivers follow strict safety, hygiene, and compliance guidelines.',
  },
  {
    question: 'What payment modes are accepted for office pickup and drop services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate billing options.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Deshpande',
    feedback: 'The office pickup and drop service by Pune Corporate Cars India Private Limited is extremely punctual and reliable. Perfect for daily commute.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rutuja More',
    feedback: 'Clean cabs, professional drivers, and smooth coordination. Highly recommended for employee transportation in Pune.',
    rating: 5,
  },
];














































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Office Pickup and Drop Service in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/office-pick-drop-pune.jpg", // replace with actual image URL
  "description": "Reliable office pickup and drop services in Pune for employees and corporate staff. Pune Corporate Cars India Private Limited provides daily and monthly shuttle services, employee transport, office commute cabs, and chauffeur-driven sedans and SUVs for comfortable and timely travel.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4700", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/office-pickup-drop-service-pune"
  }
};





  return (
    <div>
<Helmet>
  <title>Office Pickup and Drop Service in Pune | Employee Shuttle & Corporate Transport | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable office pickup and drop services in Pune for employees and corporate staff. Daily and monthly shuttle services, employee transport, and chauffeur-driven sedans and SUVs for comfortable corporate commuting."
  />

  <meta
    name="keywords"
    content="Employee Transportation Pune, Staff Shuttle Service Pune, Office Commute Cab Pune, Pune Employee Pick Drop, Company Cab Service Pune, Corporate Staff Mobility Pune, Best Office Transport Pune, Affordable Staff Pick Drop Pune, Office Employee Shuttle Pune, Daily Pick Drop Cab Pune, Monthly Office Transport Pune, Corporate Working Staff Cab, Business Pick Drop Service Pune, IT Office Pickup Drop Pune, Corporate Commute Provider Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Officepickupanddropserviceinpune;